import { EditCompanySmallLogoOutDto, EditCompanySmallLogoInDto } from '../../../types/company.dto'

export const EDIT_COMPANY_SMALL_LOGO = 'EDIT_COMPANY_SMALL_LOGO'
export const EDIT_COMPANY_SMALL_LOGO_SUCCESS = 'EDIT_COMPANY_SMALL_LOGO_SUCCESS'
export const EDIT_COMPANY_SMALL_LOGO_ERROR = 'EDIT_COMPANY_SMALL_LOGO_ERROR'
export const RESET_EDIT_COMPANY_SMALL_LOGO = 'RESET_EDIT_COMPANY_SMALL_LOGO'

export interface EditCompanySmallLogo {
  type: typeof EDIT_COMPANY_SMALL_LOGO
  payload: EditCompanySmallLogoOutDto
}

export interface EditCompanySmallLogoSuccess {
  type: typeof EDIT_COMPANY_SMALL_LOGO_SUCCESS
  payload: EditCompanySmallLogoInDto
}

export interface EditCompanySmallLogoError {
  type: typeof EDIT_COMPANY_SMALL_LOGO_ERROR
  payload: string | boolean
}

export interface ResetEditCompanySmallLogo {
  type: typeof RESET_EDIT_COMPANY_SMALL_LOGO
  payload: null
}
export interface State {
  data: EditCompanySmallLogoInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = EditCompanySmallLogo | EditCompanySmallLogoSuccess | EditCompanySmallLogoError | ResetEditCompanySmallLogo
